/**
 * Build redirect path for notifications based on reference and redirectSlug
 * @param {string} reference - Entity type (worker, client, booking, booking-request, etc.)
 * @param {string} redirectSlug - Entity slug (e.g., "asad-217", "booking-1")
 * @param {string} [senderMode] - Who sent the notification (worker, client, admin)
 * @returns {string|null} - Redirect path or null if no valid redirect
 */
export const getNotificationRedirectPath = (reference, redirectSlug, senderMode) => {
  if (!redirectSlug) {
    return null;
  }

  const slug = String(redirectSlug).toLowerCase().trim();
  const mode = (senderMode || "").toLowerCase().trim();
  const ref = (reference || "").toLowerCase().trim();

  // Contact Us / support ticket from worker → admin list
  if (slug.includes("support-ticket") && mode === "worker") {
    return "/contact-us-list";
  }

  // User entities (worker, client) - use role as reference
  if (ref === "worker") {
    return `/user/user-details/worker/${redirectSlug}`;
  }

  if (ref === "client") {
    return `/user/user-details/client/${redirectSlug}`;
  }

  // Booking entities
  if (ref === "booking") {
    return `/booking-review/${redirectSlug}`;
  }

  if (ref === "booking-request") {
    // For booking requests, redirect to booking review page using the booking slug
    // The redirectSlug here is the booking-request slug (e.g., "booking-request-5")
    // But we might need to redirect to the booking itself
    // For now, redirect to booking review - might need to adjust based on actual requirements
    return `/booking-review/${redirectSlug}`;
  }

  // Default: return null if reference is not recognized
  return null;
};
